module.exports = "https://coursera_assets.s3.amazonaws.com/images/0a20c81a72a1bd6e404dc0c08154c01e.svg";